import React from 'react';
import { Box } from '@mui/material';
import ProfileManager from '../components/profile/ProfileManager';

const ProfileManagerPage = () => {
  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <ProfileManager />
    </Box>
  );
};

export default ProfileManagerPage;
